export default "__VITE_ASSET__Dze6UpF3__"